<template>
  <v-card class="pa-3">
    <v-dialog v-model="breathModal" width="450" persistent>
      <v-card>
        <v-row no-gutters>
          <v-col cols="12" class="modal-header py-3">
            <v-row no-gutters>
              <v-spacer></v-spacer>
              <v-icon color="darkColor">mdi-plus</v-icon>
              <span class="modal-title-text mr-2">افزون علائم تنگی نفس</span>
              <v-spacer></v-spacer>
            </v-row>
          </v-col>
        </v-row>
        <v-card-text class="mt-4">
          <v-row no-gutters>
            <v-col cols="12">
              <v-row>
                <v-col cols="5" class="mt-3">
                  <span>تنگی نفس فعالیتی</span>
                </v-col>
                <v-radio-group v-model="breathAcitivity" row>
                  <v-radio label="بله" :value="true"></v-radio>
                  <v-radio label="خیر" :value="false"></v-radio>
                </v-radio-group>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="mt-8">
          <v-spacer></v-spacer>
          <v-btn color="darkColor" @click="addBreath()" dark rounded class="normal-letter-spacing px-12">
            ثبت
          </v-btn>
          <v-btn rounded color="darkColor" outlined @click="cancelAddBreath()" class="normal-letter-spacing px-10">
            انصراف
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="chestModal" width="700" persistent>
      <v-card>
        <v-row no-gutters>
          <v-col cols="12" class="modal-header py-3">
            <v-row no-gutters>
              <v-spacer></v-spacer>
              <v-icon color="darkColor">mdi-plus</v-icon>
              <span class="modal-title-text mr-2">افزودن علائم قفسه سینه</span>
              <v-spacer></v-spacer>
            </v-row>
          </v-col>
        </v-row>
        <v-card-text class="mt-4">
          <v-row>
            <v-col cols="6">
              <v-autocomplete :items="chestIsActivityPainTypeItmes" no-data-text="اطلاعاتی وجود ندارد" dense outlined
                item-text="title" item-value="id" label="درد فعالیتی" return-object clearable
                clear-icon="mdi-close-circle-outline" v-model="chestIsActivityPain" autocomplete="off"
                prepend-inner-icon="mdi-fireplace-off mdi-18px"></v-autocomplete>
            </v-col>
            <v-col cols="6">
              <v-autocomplete :items="allChestPainTypesForOther" no-data-text="اطلاعاتی وجود ندارد" dense outlined
                item-text="title" item-value="id" label="نوع درد" return-object clearable
                clear-icon="mdi-close-circle-outline" v-model="chestType" autocomplete="off"
                prepend-inner-icon="mdi-fireplace-off mdi-18px"></v-autocomplete>
            </v-col>
            <v-col cols="6">
              <v-autocomplete :items="allChestPainLocationsForOther" no-data-text="اطلاعاتی وجود ندارد" dense outlined
                item-text="title" item-value="id" label="محل درد" return-object clearable
                clear-icon="mdi-close-circle-outline" v-model="chestLocation" autocomplete="off"
                prepend-inner-icon="mdi-fireplace-off mdi-18px"></v-autocomplete>
            </v-col>
            <v-col cols="6">
              <v-autocomplete :items="allChestPainPropagationsForOther" no-data-text="اطلاعاتی وجود ندارد" dense
                outlined item-text="title" item-value="id" label="انتشار درد" return-object clearable
                clear-icon="mdi-close-circle-outline" v-model="chestPropagation" autocomplete="off"
                prepend-inner-icon="mdi-fireplace-off mdi-18px"></v-autocomplete>
            </v-col>
            <v-col cols="6">
              <v-autocomplete :items="allChestPainDurationsForOther" no-data-text="اطلاعاتی وجود ندارد" dense outlined
                item-text="title" item-value="id" label="مدت" return-object clearable
                clear-icon="mdi-close-circle-outline" v-model="chestPainDuration" autocomplete="off"
                prepend-inner-icon="mdi-fireplace-off mdi-18px"></v-autocomplete>
            </v-col>
            <v-col cols="6">
              <v-text-field dense outlined label="نمره درد" clearable :min="0" :max="10" @keypress="isNumber($event)"
                clear-icon="mdi-close-circle-outline" v-model="chestPainScale"
                prepend-inner-icon="mdi-fireplace-off mdi-18px"></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="mt-8">
          <v-spacer></v-spacer>
          <v-btn color="darkColor" @click="addChest()" dark rounded class="normal-letter-spacing px-12">
            ثبت
          </v-btn>
          <v-btn rounded color="darkColor" outlined @click="cancelAddChest()" class="normal-letter-spacing px-10">
            انصراف
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="vertigoModal" width="900" persistent>
      <v-card>
        <v-row no-gutters>
          <v-col cols="12" class="modal-header py-3">
            <v-row no-gutters>
              <v-spacer></v-spacer>
              <v-icon color="darkColor">mdi-plus</v-icon>
              <span class="modal-title-text mr-2">افزودن علائم سرگیجه</span>
              <v-spacer></v-spacer>
            </v-row>
          </v-col>
        </v-row>
        <v-card-text class="mt-4">
          <v-row>
            <v-col cols="12">
              <v-row>
                <span>اطلاعات تکمیلی</span>
                <v-divider class="mt-3 mr-3"></v-divider>
              </v-row>
            </v-col>
            <v-col cols="12">
              <v-row>
                <v-col cols="6">
                  <v-autocomplete :items="allVertigoTypesForOther" no-data-text="اطلاعاتی وجود ندارد" dense outlined
                    item-text="title" item-value="id" label="نوع سرگیجه" return-object clearable
                    clear-icon="mdi-close-circle-outline" v-model="vertigoType" autocomplete="off"
                    prepend-inner-icon="mdi-fireplace-off mdi-18px"></v-autocomplete>
                </v-col>
                <v-col cols="6">
                  <v-autocomplete :items="allVertigoDurationsForOther" no-data-text="اطلاعاتی وجود ندارد" dense outlined
                    item-text="title" item-value="id" label="مدت هر حمله سرگیجه" return-object clearable
                    clear-icon="mdi-close-circle-outline" v-model="vertigoDuration" autocomplete="off"
                    prepend-inner-icon="mdi-fireplace-off mdi-18px"></v-autocomplete>
                </v-col>
                <v-col cols="6">
                  <v-autocomplete :items="allVertigoAggravatingFactorsForOther" no-data-text="اطلاعاتی وجود ندارد" dense
                    outlined item-text="title" item-value="id" label="عامل تشدید کننده" return-object clearable
                    clear-icon="mdi-close-circle-outline" v-model="vertigoAggravatingFactor" autocomplete="off"
                    prepend-inner-icon="mdi-fireplace-off mdi-18px"></v-autocomplete>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12">
              <v-row>
                <span>سایر مشخصات</span>
                <v-divider class="mt-3 mr-3"></v-divider>
              </v-row>
            </v-col>
            <v-col cols="12">
              <v-row class="mt-n5">
                <v-col class="mb-n12" cols="4" v-for="item in allVertigoOtherSpecificationsForOther" :key="item.id">
                  <v-checkbox @change="vertigoOtherSpecificationsChange()" :label="item.title"
                    v-model="selectedVertigoOtherSpecifications" :value="item.title"></v-checkbox>
                </v-col>
              </v-row>
              <v-row v-if="vertigoOtherSpecificationsNoteFlag">
                <v-col cols="12">
                  <v-text-field dense outlined label="توضیحات" clearable clear-icon="mdi-close-circle-outline"
                    v-model="vertigoOtherSpecificationsNote" prepend-inner-icon="mdi-text mdi-18px"></v-text-field>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="mt-8">
          <v-spacer></v-spacer>
          <v-btn color="darkColor" @click="addVertigo()" dark rounded class="normal-letter-spacing px-12">
            ثبت
          </v-btn>
          <v-btn rounded color="darkColor" outlined @click="canceAddVertigo()" class="normal-letter-spacing px-10">
            انصراف
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="befastModal" width="450" persistent>
      <v-card>
        <v-row no-gutters>
          <v-col cols="12" class="modal-header py-3">
            <v-row no-gutters>
              <v-spacer></v-spacer>
              <v-icon color="darkColor">mdi-plus</v-icon>
              <span class="modal-title-text mr-2">افزودن علائم BE FAST</span>
              <v-spacer></v-spacer>
            </v-row>
          </v-col>
        </v-row>
        <v-card-text class="mt-4">
          <v-row no-gutters>
            <v-col cols="12">
              <v-row>
                <v-col cols="5" class="mt-3">
                  <span>عدم تعادل</span>
                </v-col>
                <v-radio-group v-model="befastImbalance" row>
                  <v-radio label="بله" :value="true"></v-radio>
                  <v-radio label="خیر" :value="false"></v-radio>
                </v-radio-group>
              </v-row>
            </v-col>
            <v-col cols="12">
              <v-row>
                <v-col cols="5" class="mt-3">
                  <span>تغییرات بینایی</span>
                </v-col>
                <v-radio-group v-model="befastVisionChanges" row>
                  <v-radio label="بله" :value="true"></v-radio>
                  <v-radio label="خیر" :value="false"></v-radio>
                </v-radio-group>
              </v-row>
            </v-col>
            <v-col cols="12">
              <v-row>
                <v-col cols="5" class="mt-3">
                  <span>افتادگی صورت</span>
                </v-col>
                <v-radio-group v-model="befastSaggingFace" row>
                  <v-radio label="بله" :value="true"></v-radio>
                  <v-radio label="خیر" :value="false"></v-radio>
                </v-radio-group>
              </v-row>
            </v-col>
            <v-col cols="12">
              <v-row>
                <v-col cols="5" class="mt-3">
                  <span>ضعف یا فلج اندام ها</span>
                </v-col>
                <v-radio-group v-model="befastParalysis" row>
                  <v-radio label="بله" :value="true"></v-radio>
                  <v-radio label="خیر" :value="false"></v-radio>
                </v-radio-group>
              </v-row>
            </v-col>
            <v-col cols="12">
              <v-row>
                <v-col cols="5" class="mt-3">
                  <span>اشکال در صحبت کردن</span>
                </v-col>
                <v-radio-group v-model="befastTalkingProblem" row>
                  <v-radio label="بله" :value="true"></v-radio>
                  <v-radio label="خیر" :value="false"></v-radio>
                </v-radio-group>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="mt-8">
          <v-spacer></v-spacer>
          <v-btn color="darkColor" @click="addBefast()" dark rounded class="normal-letter-spacing px-12">
            ثبت
          </v-btn>
          <v-btn rounded color="darkColor" outlined @click="cancelAddBefast()" class="normal-letter-spacing px-10">
            انصراف
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="headechModal" width="1200" persistent>
      <v-card>
        <v-row no-gutters>
          <v-col cols="12" class="modal-header py-3">
            <v-row no-gutters>
              <v-spacer></v-spacer>
              <v-icon color="darkColor">mdi-plus</v-icon>
              <span class="modal-title-text mr-2">افزودن علائم حیاتی</span>
              <v-spacer></v-spacer>
            </v-row>
          </v-col>
        </v-row>
        <v-card-text class="mt-4">
          <v-row no-gutters>
            <v-col cols="12">
              <v-row>
                <span>اطلاعات تکمیلی</span>
                <v-divider class="mt-3 mr-3"></v-divider>
              </v-row>
              <v-row>
                <v-col cols="4">
                  <v-autocomplete :items="allHeadacheTypesForOther" no-data-text="اطلاعاتی وجود ندارد" dense outlined
                    item-text="title" item-value="id" label="نوع درد" return-object clearable
                    clear-icon="mdi-close-circle-outline" v-model="headacheType" autocomplete="off"
                    prepend-inner-icon="mdi-fireplace-off mdi-18px"></v-autocomplete>
                </v-col>
                <v-col cols="4">
                  <v-autocomplete :items="allHeadacheLocationsForOther" no-data-text="اطلاعاتی وجود ندارد" dense
                    outlined item-text="title" item-value="id" return-object label="محل درد" clearable
                    clear-icon="mdi-close-circle-outline" v-model="headacheLocation" autocomplete="off"
                    prepend-inner-icon="mdi-human mdi-18px"></v-autocomplete>
                </v-col>
                <v-col cols="4">
                  <v-autocomplete :items="allHeadacheOtherSignsForOther" no-data-text="اطلاعاتی وجود ندارد" dense
                    outlined item-text="title" item-value="id" label="علائم همراه" clearable return-object
                    clear-icon="mdi-close-circle-outline" v-model="headacheOtherSign" autocomplete="off"
                    prepend-inner-icon="mdi-human mdi-18px"></v-autocomplete>
                </v-col>
              </v-row>
              <v-row class="mt-n4">
                <span>سایر مشخصات</span>
                <v-divider class="mt-3 mr-3"></v-divider>
              </v-row>
              <v-row class="mt-n5">
                <v-col class="mb-n12" cols="4" v-for="item in allHeadacheOtherSpecificationsForOther" :key="item.id">
                  <v-checkbox :label="item.title" v-model="selectedHeadacheOtherSpecifications" :value="item.title"
                    @change="headacheOtherSpecificationsChange()"></v-checkbox>
                </v-col>
                <v-col cols="12" v-if="headacheOtherSpecificationsNoteFlag" class="mt-5 mb-n9">
                  <v-text-field outlined clearable dense label="توضیحات" clear-icon="mdi-close-circle-outline"
                    v-model="headacheOtherSpecificationsNote" prepend-inner-icon="mdi-text mdi-18px"></v-text-field>
                </v-col>
              </v-row>
              <v-row class="mt-9">
                <span>سابقه بیماری</span>
                <v-divider class="mt-3 mr-3"></v-divider>
              </v-row>
              <v-row class="mt-n5">
                <v-col cols="4" v-for="item in allHeadacheIllnessHistoriesForOther" :key="item.id" class="mb-n12">
                  <v-checkbox :label="item.title" v-model="selectedHeadacheIllnessHistories"
                    :value="item.title"></v-checkbox>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="mt-8">
          <v-spacer></v-spacer>
          <v-btn color="darkColor" @click="addHeadache()" dark rounded class="normal-letter-spacing px-12">
            ثبت
          </v-btn>
          <v-btn rounded color="darkColor" outlined @click="cancelAddHeadache()" class="normal-letter-spacing px-10">
            انصراف
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-row no-gutters>
      <v-col cols="12" class="modal-header py-3 mb-4">
        <v-row no-gutters>
          <v-spacer></v-spacer>
          <v-col cols="10">
            <span class="text-center text-lg d-block font-weight-medium w-full">علائم همراه</span>
          </v-col>
          <v-col cols="1" class="text-left mt-n2 ml-2">
            <v-icon color="darkColor" @click="closeDialog()">mdi-close</v-icon>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row v-if="true" no-gutters class="none-truma-section ma-0">
      <v-col cols="7">
        <v-row class="mr-0">
          <span>علائم همراه</span>
          <v-divider class="mt-3 mr-3 ml-5"></v-divider>
        </v-row>
        <v-row>
          <!-- <v-col cols="12">
            <v-btn block color="darkColor" outlined large v-if="!isBeFast"
              @click="changePatientAccompanyingSymptomType(1)">
              علائم BE FAST
            </v-btn>
            <v-btn block color="darkColor" dark large v-else>علائم BE FAST</v-btn>
          </v-col>
          <v-col cols="12">
            <v-btn block color="darkColor" outlined large v-if="!isHeadech"
              @click="changePatientAccompanyingSymptomType(2)">
              سردرد
            </v-btn>
            <v-btn block color="darkColor" dark large v-else>سردرد</v-btn>
          </v-col>
          <v-col cols="12">
            <v-btn block color="darkColor" outlined large v-if="!isDizziness"
              @click="changePatientAccompanyingSymptomType(3)">
              سرگیجه
            </v-btn>
            <v-btn block color="darkColor" dark large v-else>سرگیجه</v-btn>
          </v-col>
          <v-col cols="12">
            <v-btn block color="darkColor" outlined large v-if="!isChest"
              @click="changePatientAccompanyingSymptomType(4)">
              درد قفسه سینه
            </v-btn>
            <v-btn block color="darkColor" dark large v-else>درد قفسه سینه</v-btn>
          </v-col>
          <v-col cols="12">
            <v-btn block color="darkColor" outlined large v-if="!isBreath"
              @click="changePatientAccompanyingSymptomType(5)">
              تنگی نفس
            </v-btn>
            <v-btn block color="darkColor" dark large v-else>تنگی نفس</v-btn>
          </v-col> -->
          <v-col cols="4" v-for="item in filteredSymptoms" :key="item.id">
            <v-btn block color="darkColor" large :outlined="!isItemSelected(item)" :dark="isItemSelected(item)"
              @click="!isItemSelected(item) && handleClickItem(item)">
              {{ item.title }}
            </v-btn>
          </v-col>
          <v-col cols="12">
            <!-- <v-row no-gutters class="gap-2">
              <v-col>
                <v-autocomplete hide-details no-data-text="اطلاعاتی وجود ندارد" dense outlined item-text="title"
                  item-value="title" label="سایر علائم" clearable clear-icon="mdi-close-circle-outline"
                  :items="mainPatientAccompanyingSymptomsTypeList" v-model="otherAccompanyingSymptom" autocomplete="off"
                  prepend-inner-icon="mdi-medication mdi-18px"></v-autocomplete>
              </v-col>
              <v-col cols="2" v-if="otherAccompanyingSymptom !== 'سایر'">
                <v-btn icon dark tile class="darkColor" @click="addOtherPatientAccompanyingSymptomNotTruma">
                  <v-icon>mdi-plus mdi-18px</v-icon>
                </v-btn>
              </v-col>
            </v-row>
            <v-row v-if="otherAccompanyingSymptom === 'سایر'" no-gutters class="gap-2 mt-2"> -->
            <v-row no-gutters class="gap-2 mt-2">
              <v-col>
                <v-text-field dense outlined label="سایر با ذکر نام" prepend-inner-icon="mdi-medication mdi-18px"
                  v-model="otherAccompanyingSymptomText"></v-text-field>
              </v-col>
              <v-col cols="2">
                <v-btn icon dark tile class="darkColor" @click="addOtherPatientAccompanyingSymptomNotTruma">
                  <v-icon>mdi-plus mdi-18px</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="5" class="pr-7">
        <v-row>
          <span>علائم همراه انتخابی</span>
          <v-divider class="mt-3 mr-3 ml-3"></v-divider>
        </v-row>
        <v-row>
          <v-col cols="12" v-if="importedData.length > 0" class="detail-part">
            <v-card elevation="0" class="detail-card mt-3" v-for="item in importedData" :key="item.id">
              <v-card-text>
                <v-row>
                  <v-col cols="12">
                    <v-row>
                      <v-icon color="darkColor" class="mr-2 my-2"
                        @click="deletePatientAccompanyingSymptomFunction(item.mainId)">
                        mdi-close-circle mdi-18px
                      </v-icon>
                      <span class="mr-4 mt-2">{{ item.title }}</span>
                      <template v-if="flagShowForm == 3">
                        <v-spacer></v-spacer>
                        <v-icon class="ml-4" @click="openDetail(item.mainId)"
                          v-if="item.hasDetail == true && item.showDetail == false">
                          mdi-chevron-down mdi-18px
                        </v-icon>
                        <v-icon class="ml-4" @click="closeDetail(item.mainId)"
                          v-if="item.hasDetail == true && item.showDetail == true">
                          mdi-chevron-up mdi-18px
                        </v-icon>
                      </template>
                    </v-row>
                    <v-row v-if="item.hasDetail == true && item.showDetail == true">
                      <v-col cols="12">
                        <v-divider></v-divider>
                      </v-col>
                      <v-col cols="12" v-for="(subItem, index) in item.info" :key="index">
                        <v-row>
                          <span class="detail-content mr-10">{{ subItem.content }}:</span>
                          <span class="mr-5">{{ subItem.title }}</span>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <template v-else>
      <v-row class="ma-0">
        <v-col cols="12">
          <v-row class="ma-0">
            <v-col cols="6">
              <v-row class="mr-0">
                <span>علائم همراه</span>
                <v-divider class="mt-3 mr-3 ml-3"></v-divider>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-card elevation="0" class="card-style" height="32vh">
                    <!-- (flagShowForm == 2
                        ? patientAccompanyingSymptomsTypeList_2
                        : flagShowForm == 3
                          ? patientAccompanyingSymptomsTypeList_3
                          : flagShowForm == 4 ? patientAccompanyingSymptomsTypeList_4
                            : flagShowForm == 5
                              ? patientAccompanyingSymptomsTypeList_5 :
                              patientAccompanyingSymptomsTypeList)"  -->
                    <v-chip
                      v-for="item in all_PatientAccompanyingSymptomsTypeList?.filter(i => i?.for?.includes(flagShowForm))"
                      :key="item.id" label color="background" text-color="darkColor" class="mr-2 mt-2"
                      @click="handleClickItem(item)">
                      {{ item.title }}
                      <v-icon class="mr-3" color="darkColor">
                        mdi-plus mdi-18px
                      </v-icon>
                    </v-chip>
                  </v-card>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="6">
              <v-row>
                <span>علائم همراه انتخابی</span>
                <v-divider class="mt-3 mr-3"></v-divider>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-card elevation="0" class="card-style" height="32vh">
                    <v-chip v-for="item in selectedPatientAccompanyingSymptomsTypeList" :key="item.id" color="darkColor"
                      text-color="white" class="mr-2 mt-2">
                      {{ item.title }}
                      <v-icon class="mr-3" color="white" @click="deletePatientAccompanyingSymptomFunction(item)">
                        mdi-close mdi-18px
                      </v-icon>
                    </v-chip>
                  </v-card>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row class="ma-0">
            <span>سایر علائم</span>
            <v-divider class="mt-3 mr-3"></v-divider>
          </v-row>
          <v-row class="ma-0">
            <v-col cols="6">
              <v-text-field outlined label="سایر علائم" dense v-model="otherPatientAccompanyingSymptom"
                prepend-inner-icon="mdi-text mdi-18px" clearable clear-icon="mdi-close-circle-outline">
                <template v-slot:append-outer>
                  <v-btn color="darkColor" x-small elevation="0" class="py-5 mt-n2"
                    v-on:keyup.enter="addOtherPatientAccompanyingSymptom()"
                    @click="addOtherPatientAccompanyingSymptom()">
                    <v-icon color="white">mdi-plus mdi-18px</v-icon>
                  </v-btn>
                </template>
              </v-text-field>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </template>
    <v-row class="ma-0">
      <v-spacer></v-spacer>
      <v-btn rounded color="darkColor" dark @click="nextDialog()">بعدی (تاریخچه پزشکی)</v-btn>
      <v-btn text color="darkColor" @click="closeDialog()">بستن</v-btn>
    </v-row>
  </v-card>
</template>
<script>
import FollowUpPatientStep5Helper from '@/Helpers/FollowUp/FollowUpPatientPart/FollowUpPatientStep5Helper';
import PatientAccompanyingSymptomMixin from '@/Mixins/FollowUp/FollowUpPatientPart/PatientAccompanyingSymptomMixin.js';
import HeadacheOtherSpecificationMixin from '@/Mixins/FollowUp/HeadacheOtherSpecificationMixin.js';
import HeadacheOtherSignMixin from '@/Mixins/FollowUp/HeadacheOtherSignMixin.js';
import HeadacheLocationMixin from '@/Mixins/FollowUp/HeadacheLocationMixin.js';
import HeadacheTypeMixin from '@/Mixins/FollowUp/HeadacheTypeMixin.js';
import HeadacheIllnessHistoryMixin from '@/Mixins/FollowUp/HeadacheIllnessHistoryMixin.js';
import VertigoAggravatingFactorMixin from '@/Mixins/FollowUp/VertigoAggravatingFactorMixin';
import VertigoDurationMixin from '@/Mixins/FollowUp/VertigoDurationMixin';
import VertigoOtherSpecificationMixin from '@/Mixins/FollowUp/VertigoOtherSpecificationMixin';
import VertigoTypeMixin from '@/Mixins/FollowUp/VertigoTypeMixin';
import ChestPainDurationMixin from '@/Mixins/FollowUp/ChestPainDurationMixin';
import ChestPainLocationMixin from '@/Mixins/FollowUp/ChestPainLocationMixin';
import ChestPainPropagationMixin from '@/Mixins/FollowUp/ChestPainPropagationMixin';
import ChestPainTypeMixin from '@/Mixins/FollowUp/ChestPainTypeMixin';
import SharedHelper from '@/Helpers/Shared';
import SharedMixin from '@/Mixins/Shared';

export default {
  mixins: [
    FollowUpPatientStep5Helper,
    PatientAccompanyingSymptomMixin,
    SharedHelper,
    SharedMixin,
    HeadacheOtherSpecificationMixin,
    HeadacheOtherSignMixin,
    HeadacheLocationMixin,
    HeadacheIllnessHistoryMixin,
    HeadacheTypeMixin,
    VertigoAggravatingFactorMixin,
    VertigoDurationMixin,
    VertigoOtherSpecificationMixin,
    VertigoTypeMixin,
    ChestPainDurationMixin,
    ChestPainLocationMixin,
    ChestPainPropagationMixin,
    ChestPainTypeMixin,
  ],
  mounted() {
    this.mounteLoding();
  },
  props: {
    patientId: {
      type: Number,
      require: true,
      default: null,
    },
    missionType: {
      type: String,
      require: true,
      default: '',
    },
    flagShowForm: {
      type: Number,
      require: true,
      default: null,
    },
  },
  computed: {
    filteredSymptoms() {
      return this.all_PatientAccompanyingSymptomsTypeList?.filter(
        i => i?.for?.includes(this.flagShowForm)
      ) || [];
    },
  },
  methods: {
    mounte: function () {
      this.getAllPatientAccompanyingSymptomFunction(this.patientId);
    },
    closeDialog() {
      this.$emit('reloadApiFun');
    },
    nextDialog() {
      this.$emit('goToNextDialog');
    },
    isItemSelected(item) {
      if (item.title?.includes("سردرد")) {
        return this.importedData?.some(i => i.title === item.title) || false;
      } else {
        return this.importedData?.some(i => item.title?.includes(i.title) || i.title?.includes(item.title)) || false;
      }

    },
    handleClickItem(item) {
      if (item?.hasDialog && this.flagShowForm == 3) {
        this.changePatientAccompanyingSymptomType(item.idDialog)
      } else {
        this.addPatientAccompanyingSymptomTrumaType(item.title)
      }

    }
  },
  data() {
    return {
      localFlagShowForm: null,
    };
  },
  watch: {
    flagShowForm: {
      handler(newVal) {
        this.localFlagShowForm = newVal;
      },
      immediate: true,
    },
  },
};
</script>
<style lang="scss" scoped>
.none-truma-section {
  padding-top: 0.5rem;
  height: 520px;
  // overflow-y: auto;
  // overflow-x: hidden;
  overflow: hidden;
}
</style>
<style scoped>
.card-style {
  border: 1px solid var(--dark-color) !important;
  border-radius: 10px !important;
  overflow-y: auto;
}

.detail-card {
  background: var(--background-color) !important;
  border-radius: 8px !important;
}

.detail-part {
  height: 70vh;
  overflow-y: auto;
}

.detail-content {
  font-weight: 600;
  font-size: 14px;
  color: #212121;
}
</style>
